<script lang="ts" setup>
withDefaults(
  defineProps<{
    isActive?: boolean
    isDisabled?: boolean
    title: string
    text?: string | null
  }>(),
  { isActive: false, isDisabled: false, text: null }
)
</script>

<template>
  <a
    class="
      flex flex-col items-center rounded-xl border-[1.5px] bg-[#F6F6F6] p-4 leading-normal
      text-[#434242] !no-underline md:tracking-[-0.01em]
    "
    :class="{ 'border-main-green': isActive, '[&_span]:!text-[#B4B4B4]': isDisabled }"
    href="#"
  >
    <span class="block text-sm leading-[1.43] text-[#434242] md:text-base md:leading-normal">
      {{ title }}
    </span>

    <span v-if="text" class="text-xs leading-[1.33] text-main-silver md:text-sm md:leading-[1.71]">
      {{ text }}
    </span>
  </a>
</template>
